import moment from 'moment';

export const canSubmitRepeating = (task, creating) => {
  const basicInfoValid = validBasicInfo(task, creating);
  return (
    basicInfoValid && validDueOptions(task) && validAssignees(task, creating)
  );
};

export const canSubmitImmediate = (task, creating) => {
  const basicInfoValid = validBasicInfo(task, creating);
  return (
    basicInfoValid &&
    validDueDate(task, creating) &&
    validAssignees(task, creating) &&
    !task?.alreadyUsed
  );
};

export const validDueDate = (task, creating) =>
  task?.dueDate && creating
    ? moment(task?.dueDate).isAfter(moment(task?.assignOn))
    : true;

export const filterOutFullGroups = (
  groupDropdown,
  pairs = [],
  selectedGroup
) => {
  const groups = (pairs ?? []).reduce((groupsSoFar, { groupId, projectId }) => {
    if (!groupsSoFar[groupId]) groupsSoFar[groupId] = [];
    groupsSoFar[groupId].push(projectId ?? 'none');
    return groupsSoFar;
  }, {});

  let filteredDropdown = [];
  for (const g of groupDropdown) {
    if (
      groups?.[g.value]?.length !== g?.projects?.length + 1 ||
      g.value === selectedGroup
    )
      filteredDropdown.push(g);
  }
  return filteredDropdown;
};

export const duplicateGroupAreaPairs = groups => {
  const filteredArr = groups.reduce((acc, current) => {
    const x = acc.find(
      item =>
        item.groupId &&
        item.groupId === current.groupId &&
        item.projectId === current.projectId
    );
    if (!x) {
      return acc.concat([current]);
    } else {
      return acc;
    }
  }, []);

  return filteredArr?.length !== groups?.length;
};

const validBasicInfo = (task, creating) =>
  task?.label && task?.description && (creating ? true : task?.groupId);

const validAssignees = (task, creating) =>
  creating
    ? task?.groupAssigneePairs?.length &&
      task?.groupAssigneePairs?.every(a => a.groupId && a.assignees?.length)
    : task?.assignedTo?.length;

const validDueOptions = task => {
  return (
    task?.frequency &&
    parseInt(task?.dueByNumber) > -1 &&
    task?.dueBy &&
    task?.dueByTime &&
    (task?.repeatingOn?.length || task?.frequency === 'quarterly')
  );
};
